import type { RouteRecordRaw } from 'vue-router'

import { AdokLayout as Layout } from '@/apps/adok/app/layout'

const ReferralsPage = () =>
  import('@/apps/adok/pages/referrals').then((m) => m.ReferralsPage)

const referralsRoutes: RouteRecordRaw[] = [
  {
    path: '/referrals',
    component: Layout,
    children: [
      {
        path: '',
        name: 'referrals',
        component: ReferralsPage,
        meta: {
          title: 'Referrals'
        }
      }
    ]
  }
]

export default referralsRoutes
